import React from 'react';
import Grid from '../layout/grid';
import Select from 'react-select';

export default props => (
    <Grid cols={props.cols}>
        <div className='form-group'>
			<label style={{ fontWeight: 'normal' }} htmlFor={props.name}>{props.label}</label>
			{props.multiple ? (
				<Select
					styles={{
						control: (provided) => ({
							...provided,
							color: '#000000', // Define a cor do texto dentro do input
						}),
						singleValue: (provided) => ({
							...provided,
							color: '#000000' // Define a cor do item selecionado
						}),
						option: (provided, state) => ({
							...provided,
							color: state.isSelected ? '#ffffff' : '#000000' // Texto azul, branco se estiver selecionado
						})
					}}
					readOnly={props.readOnly}
					isMulti
					defaultValue={props.value}
					isClearable={true}
					isSearchable={true}
					onChange={(item) => props.onChange(item)}
					options={(props.options || []).map(opt => ({ value: opt.id, label: opt.valor }))} />
			) : (props.onChange ? (
				<Select
					styles={{
						control: (provided) => ({
							...provided,
							color: '#000000', // Define a cor do texto dentro do input
						}),
						singleValue: (provided) => ({
							...provided,
							color: '#000000' // Define a cor do item selecionado
						}),
						option: (provided, state) => ({
							...provided,
							color: state.isSelected ? '#ffffff' : '#000000' // Texto azul, branco se estiver selecionado
						})
					}}
					readOnly={props.readOnly}
					defaultValue={props.value ? (props.options || []).map(opt => ({ value: String(opt.id), label: opt.valor })).filter(opt => opt.value == props.value)[0] || null : null}
					isClearable={true}
					isSearchable={true}
					isDisabled={props.readOnly ? true : false}
					onChange={(item) => props.onChange(item ? item.value : null)}
					options={(props.options || []).map(opt => ({ value: opt.id, label: opt.valor }))} />
			) : (
				<Select
					styles={{
						control: (provided) => ({
							...provided,
							color: '#000000', // Define a cor do texto dentro do input
						}),
						singleValue: (provided) => ({
							...provided,
							color: '#000000' // Define a cor do item selecionado
						}),
						option: (provided, state) => ({
							...provided,
							color: state.isSelected ? '#ffffff' : '#000000' // Texto azul, branco se estiver selecionado
						})
					}}
					readOnly={props.readOnly}
					isClearable={true}
					isSearchable={true}
					isDisabled={props.readOnly ? true : false}
					defaultValue={props.input.value ? (props.options || []).map(opt => ({ value: String(opt.id), label: opt.valor })).filter(opt => opt.value == props.input.value)[0] || null : null}
					onChange={(item) => props.input.onChange(item ? item.value : null)}
					onBlur={(value) => props.input.onBlur()}
					options={(props.options || []).map(opt => ({ value: opt.id, label: opt.valor }))} />
			))}
       </div>
   </Grid>
)
